import '../sass/style.scss';
import axios from 'axios';

function getUrlParams(param) {
  var urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
};

// load main page video
(function() {
  var introVideo = document.getElementsByClassName('js-app-video');
  if(introVideo.length < 1) return;
  var loaded = false;
  introVideo[0].addEventListener('loadeddata', function(event) {
    // video has been loaded
    if(loaded == true) return;
    loaded = true;
    showIntroVideo();
  }, {once: true});

  if ( introVideo[0].readyState === 4 ) {
    // already in cache
    if(loaded == true) return;
    loaded = true;
    showIntroVideo();
  }

  function showIntroVideo() {
    introVideo[0].previousElementSibling.classList.add('hide');
    introVideo[0].classList.remove('hide');
  };
}());

// File#: _1_tabs
// Usage: codyhouse.co/license
(function() {
	var Tab = function(element) {
		this.element = element;
		this.tabList = this.element.getElementsByClassName('js-tabs__controls')[0];
		this.listItems = this.tabList.getElementsByClassName('js-tabs__btn');
		// this.triggers = this.tabList.getElementsByTagName('a');
		this.panelsList = this.element.getElementsByClassName('js-tabs__panels')[0];
		this.panels = getChildrenByClassName(this.panelsList, 'js-tabs__panel');
		this.hideClass = this.element.getAttribute('data-hide-panel-class') ? this.element.getAttribute('data-hide-panel-class') : 'hide';
		this.customShowClass = this.element.getAttribute('data-show-panel-class') ? this.element.getAttribute('data-show-panel-class') : false;
		this.layout = this.element.getAttribute('data-tabs-layout') ? this.element.getAttribute('data-tabs-layout') : 'horizontal';
		// deep linking options
		this.deepLinkOn = this.element.getAttribute('data-deep-link') == 'on';
		// init tabs
		this.initTab();
	};

	Tab.prototype.initTab = function() {
		//set initial aria attributes
		this.tabList.setAttribute('role', 'tablist');
    this.element.classList.add('tabs--no-interaction');
    var initialSelection = getInitialSelection(this);

		for( var i = 0; i < this.listItems.length; i++) {
			var bool = (i == initialSelection);
      this.listItems[i].setAttribute('aria-selected', bool);

      this.panels[i].classList.toggle(this.hideClass, !bool);
			
			if(bool && this.customShowClass) this.panels[i].classList.add(this.customShowClass);
		}

		//listen for Tab events
		this.initTabEvents();
	};

	Tab.prototype.initTabEvents = function() {
		var self = this;
		//click on a new tab -> select content
		this.tabList.addEventListener('click', function(event) {
			if( event.target.closest('.js-tabs__btn') ) self.triggerTab(event.target.closest('.js-tabs__btn'), event);
		});
		//arrow keys to navigate through tabs 
		this.tabList.addEventListener('keydown', function(event) {
			;
			if( !event.target.closest('.js-tabs__btn') ) return;
			if( tabNavigateNext(event, self.layout) ) {
				event.preventDefault();
				self.selectNewTab('next');
			} else if( tabNavigatePrev(event, self.layout) ) {
				event.preventDefault();
				self.selectNewTab('prev');
			}
		});
	};

	Tab.prototype.selectNewTab = function(direction) {
		var selectedTab = this.tabList.querySelector('[aria-selected="true"]'),
			index = Array.prototype.indexOf.call(this.listItems, selectedTab);
      
		index = (direction == 'next') ? index + 1 : index - 1;
		//make sure index is in the correct interval 
		//-> from last element go to first using the right arrow, from first element go to last using the left arrow
		if(index < 0) index = this.listItems.length - 1;
		if(index >= this.listItems.length) index = 0;	
		this.triggerTab(this.listItems[index]);
		this.listItems[index].focus();
	};

	Tab.prototype.triggerTab = function(tabTrigger, event) {
		var self = this;
		event && event.preventDefault();	
		var index = Array.prototype.indexOf.call(this.listItems, tabTrigger);

		//no need to do anything if tab was already selected
		if(this.listItems[index].getAttribute('aria-selected') == 'true') return;
		
    this.element.classList.remove('tabs--no-interaction');
		
		for( var i = 0; i < this.listItems.length; i++) {
			var bool = (i == index);
      this.panels[i].classList.toggle(this.hideClass, !bool);
			if(this.customShowClass) this.panels[i].classList.toggle(this.customShowClass, bool);
			this.listItems[i].setAttribute('aria-selected', bool);
		}

    // emit custom event to detect the tab was changed
    this.element.dispatchEvent(new CustomEvent('tabUpdated', {detail: index}));
	};

	function tabNavigateNext(event, layout) {
		if(layout == 'horizontal' && (event.keyCode && event.keyCode == 39 || event.key && event.key == 'ArrowRight')) {return true;}
		else if(layout == 'vertical' && (event.keyCode && event.keyCode == 40 || event.key && event.key == 'ArrowDown')) {return true;}
		else {return false;}
	};

	function tabNavigatePrev(event, layout) {
		if(layout == 'horizontal' && (event.keyCode && event.keyCode == 37 || event.key && event.key == 'ArrowLeft')) {return true;}
		else if(layout == 'vertical' && (event.keyCode && event.keyCode == 38 || event.key && event.key == 'ArrowUp')) {return true;}
		else {return false;}
	};

  function getChildrenByClassName(el, className) {
    var children = el.children,
      childrenByClass = [];
    for (var i = 0; i < children.length; i++) {
      if (children[i].classList.contains(className)) childrenByClass.push(children[i]);
    }
    return childrenByClass;
  };

  function getInitialSelection(el) {
    var initSelection = 0;
    for(var i = 0; i < el.listItems.length; i++) {
      if(el.listItems[i].getAttribute('aria-selected')) {
        initSelection = i;
        break;
      }
    }
    return initSelection;
  };

	window.Tab = Tab;
	
	//initialize the Tab objects
	var tabs = document.getElementsByClassName('js-tabs-2');
	if( tabs.length > 0 ) {
		for( var i = 0; i < tabs.length; i++) {
			(function(i){
        // if this is the login tab -> I want to select the panel to be showed before initializing the tab
        if(tabs[i].classList.contains('js-login-tabs') && getUrlParams('login-tab') == 'create') {
          var createAccountTab = tabs[i].getElementsByClassName('js-login-tabs__new-account');
          if(createAccountTab.length > 0) createAccountTab[i].setAttribute('aria-selected', true);
        }
        new Tab(tabs[i]);
      })(i);
		}
	}
}());

// File#: _1_notice
// Usage: codyhouse.co/license
(function() {
  function initNoticeEvents(notice) {
    notice.addEventListener('click', function(event){
      if(event.target.closest('.js-notice__hide-control')) {
        event.preventDefault();
        notice.classList.add('notice--hide');
      }
    });
  };
  
  var noticeElements = document.getElementsByClassName('js-notice');
  if(noticeElements.length > 0) {
    for(var i=0; i < noticeElements.length; i++) {(function(i){
      initNoticeEvents(noticeElements[i]);
    })(i);}
  }
}());

// Login/Reset Password/create account form
(function() {
  var FormSubmit = function(element, type) {
    this.element = element;
    this.submitBtn = this.element.getElementsByClassName('js-form-submit__btn');
    this.email = this.element.querySelector('input[name="email"]');
    this.password = this.element.querySelector('input[name="password"]');
    this.errorMessage = this.element.getElementsByClassName('js-error-msg');
    this.successMessage = this.element.getElementsByClassName('js-success-msg');
    initForm(this);
  };

  function initForm(element) {
    element.element.addEventListener('submit', function(event) {
      event.preventDefault();
      // show loader
      if(element.submitBtn.length > 0) element.submitBtn[0].classList.add('btn-states--state-b');
      for(var i = 0; i < element.errorMessage.length; i++) {
        element.errorMessage[i].classList.add('hide');
      }
      if(element.successMessage.length > 0) element.successMessage[0].classList.add('hide');

      if(element.element.classList.contains('js-form-submit--login')) {
        loginSubmit(element);
      } else if(element.element.classList.contains('js-form-submit--forgot')) {
        forgotSubmit(element);
      } else if(element.element.classList.contains('js-form-submit--reset')) {
        resetSubmit(element);
      } else if(element.element.classList.contains('js-form-submit--signup')) {
        signupSubmit(element);
      }
    });
  };

  function redirectApp(element, getAttr) {
    var url = '/app';
    if(getAttr) url =  url + getAttr;
    window.location.href = url;
  };

  function formError(element) {
    removeLoader(element);
    if(element.errorMessage.length > 0) element.errorMessage[0].classList.remove('hide');
  };

  function removeLoader(element) {
    if(element.submitBtn.length > 0) element.submitBtn[0].classList.remove('btn-states--state-b');
  };

  function loginSubmit(element) {
    var info = {};
    info.email = element.email.value;

    if(element.password.value.trim() != '') {
      info.password = element.password.value;
    }

    // check if there's a prompt_id that should be saved
    var promptId = getUrlParams('save-prompt');
    if(promptId) {
      info.promptId = promptId;
    }

    axios.post('/login', info)
    .then(function (response) {
      if(response.data == 'success') {
        redirectApp(element);
      } else if(response.data == 'success-no-prompt') {
        redirectApp(element, '?free-limit=reached');
      } else {
        formError(element);
      }
    }).catch(function (error) {
      formError(element);
    });
  };

  function forgotSubmit(element) {
    var info = {};
    info.email = element.email.value;
    axios.post('/lost-password', info)
    .then(function (response) {
      removeLoader(element);
      if(response.data == 'success') {
        // show success message
        if(element.successMessage.length > 0) element.successMessage[0].classList.remove('hide');
      } else {
        formError(element);
      }
    }).catch(function (error) {
      formError(element);
    });
  };

  function resetSubmit(element) {
    var tokenArray = window.location.href.split('/reset-password/');
    var token = tokenArray.length > 0 ? tokenArray[1] : '';
    var info = {};
    if(element.password.value.trim() != '') {
      info.password = element.password.value;
    }
    axios.post('/reset-password/'+token, info)
    .then(function (response) {
      if(response.data == 'success') {
        // the redirect should be automatic -> this should never be triggered
        redirectApp(element, '?password-updated=success');
      } else {
        removeLoader(element);
        formError(element);
      }
    }).catch(function (error) {
      formError(element);
    });
  };

  function signupSubmit(element) {
    var info = {};
    info.email = element.email.value;
    if(element.password.value.trim() != '') {
      info.password = element.password.value;
    }

    var promptId = getUrlParams('save-prompt');
    if(promptId) {
      info.promptId = promptId;
    }

    axios.post('/signup', info)
    .then(function (response) {
      if(response.data == 'success') {
        redirectApp(element);
      } else if(response.data == 'error') {
        formError(element);
      } else {
        // there's a specific error -> show it
        showCustomError(element, response.data);
      }
    }).catch(function (error) {
      formError(element);
    });
  };

  function showCustomError(element, msg) {
    removeLoader(element);
    if(element.errorMessage.length > 1) {
      element.errorMessage[1].textContent = msg;
      element.errorMessage[1].classList.remove('hide');
    }
  };

  var accountForms = document.getElementsByClassName('js-form-submit');
	if( accountForms.length > 0 ) {
    for( var i = 0; i < accountForms.length; i++) {
      new FormSubmit(accountForms[i]);
    }
  }
}());

// cookie banner
(function() {
  var policyBanner = document.getElementsByClassName('js-privacy-policy-alert');
	if( policyBanner.length > 0) {
		if(localStorage.getItem('imf-cookies-alert') == null ) {
			policyBanner[0].classList.remove('hide');
			localStorage.setItem('imf-cookies-alert', 'seen');
		}
	}
}());

// home page - '/imagine' animation
(function() {
  var svg = document.getElementsByClassName('js-imagine-anim');
  if(svg.length < 1) return;
  var animating = false;
  var dots = svg[0].querySelectorAll('circle');
  var indexArray = [];
  for(var i = 0; i < dots.length; i++) {
    indexArray.push(i);
  }
  var intervalId = false;

  svg[0].addEventListener('mouseover', function(){
    if(animating) return;
    animating = true;
    animateSvg();
  }, {once: true});

  function animateSvg() {
    for(var i = 0; i < dots.length; i++) {
      (function(i){
        var interval = Math.floor(Math.random() * 1000);
        setTimeout(function() {
          dots[i].classList.remove('hide');
        }, interval);
      })(i);
    }
  };
}());

// Login/create account tabs - update email/password fields
(function() {
  var loginTabs = document.getElementsByClassName('js-login-tabs');
  var forms = document.getElementsByClassName('js-form-submit');
  if(loginTabs.length < 1 || forms.length < 2) return;
  loginTabs[0].addEventListener('tabUpdated', function(event) {
    var endIndex = parseInt(event.detail),
      startIndex = endIndex == 0 ? 1 : 0;
    forms[endIndex].querySelector('input[name="email"]').value = forms[startIndex].querySelector('input[name="email"]').value;
    forms[endIndex].querySelector('input[name="password"]').value = forms[startIndex].querySelector('input[name="password"]').value;
  }); 
}());

// File#: _2_copy-to-clip
// Usage: codyhouse.co/license
(function() {
  var CopyClipboard = function() {
    this.copyTargetClass = 'js-copy-to-clip';
    this.copyStatusClass = 'prompt-menu__btn--copied';
    this.resetDelay = 1500; // delay for removing the copy-to-clip--copied class
    initCopyToClipboard(this);
  };

  function initCopyToClipboard(element) {
    document.addEventListener('click', function(event) {
      var target = event.target.closest('.'+element.copyTargetClass);
      if(!target) return;
      copyContentToClipboard(element, target);
    });
  };

  function copyContentToClipboard(element, target) {
    // copy to clipboard
    navigator.clipboard.writeText(getContentToCopy(target)).then(function() { // content successfully copied
      var successClass = target.getAttribute('data-copied-class') || element.copyStatusClass;
      // add success class to target
      target.classList.add(successClass);

      setTimeout(function(){ // remove success class from target
        target.classList.remove(successClass);
      }, element.resetDelay);
      
      // change tooltip content
      var newTitle = target.getAttribute('data-success-title');
      if(newTitle && newTitle != '') target.dispatchEvent(new CustomEvent("newContent", {detail: newTitle}));
      
      // dispatch success event
      target.dispatchEvent(new CustomEvent("contentCopied"));
    }, function() { // error while copying the code
      // dispatch error event
      target.dispatchEvent(new CustomEvent("contentNotCopied"));
    });
  };

  function getContentToCopy(target) {
    var content = target.innerText.trim();
    var ariaControls = document.getElementById(target.getAttribute('aria-controls')),
      defaultText = target.getAttribute('data-clipboard-content');
    if(ariaControls) {
      content = ariaControls.innerText.trim();
    } else if(defaultText && defaultText != '') {
      content = defaultText;
    }
    return content;
  };

  window.CopyClipboard = CopyClipboard;

  var copyToClipboard = document.getElementsByClassName('js-copy-to-clip');
  if(copyToClipboard.length > 0) {
    new CopyClipboard();
  } 
}());

// billing page actions
(function() {
  // cancel subscription
  var errorMessage = document.getElementsByClassName('js-error-msg');
  var cancelSub = document.getElementsByClassName('js-cancel-subscription');
  if(cancelSub.length > 0) {
    cancelSub[0].addEventListener('click', function(event) {
      event.preventDefault();
      toggleError(false);
      cancelSub[0].classList.add('btn-states--state-b');
      if(window.confirm("Are you sure you want to cancel your Imagifly subscription?")) {
        axios.delete('/api/delete-subscription')
        .then(function (response) {
          console.log(response);
          if(response.data && response.data.error) {
            console.log('error while updating the subscription');
            toggleError(true);
            cancelSub[0].classList.remove('btn-states--state-b');
          } else {
            // redirect to the same page
            // window.location = '/account/billing';
            setTimeout(function(){
              window.location.reload(true);
            }, 2000);
          }
        })
        .catch(function (error) {
          console.log('error while updating the subscription');
          console.log('error', error);
          toggleError(true);
          cancelSub[0].classList.remove('btn-states--state-b');
        });
      } else {
        cancelSub[0].classList.remove('btn-states--state-b');
      }
    });
  }

  // reactivate cancelled subscription
  var reactivateSub = document.getElementsByClassName('js-reactivate-subscription');
  if(reactivateSub.length > 0) {
    reactivateSub[0].addEventListener('click', function(event) {
      event.preventDefault();
      toggleError(false);
      reactivateSub[0].classList.add('btn-states--state-b');
      axios.patch('/api/reactivate-subscription')
      .then(function (response) {
        if(response.data && response.data.error) {
          console.log('error while updating the subscription');
          toggleError(true);
        } else {
          //redirect to the same page
          setTimeout(function(){
            window.location.reload(true);
          }, 2000);
          
          // window.location = '/account/billing';
        }
      })
      .catch(function (error) {
        console.log('error while updating the subscription');
        console.log('error', error);
        toggleError(true);
      });
    });
  }

  // change card info for payments
  var paymentInfo = document.getElementsByClassName('js-payment-info');
  if(paymentInfo.length > 0) {
    // get url to update the subscription payment info
    axios.get('/api/subscription')
    .then(function (response) {
      if(response.data && response.data.error) {
        console.log('error while retrieving the subscription');
      } else {
        var url = false;
        if(response.data && response.data.data && response.data.data.attributes && response.data.data.attributes.urls) url = response.data.data.attributes.urls.update_payment_method;
        if(url) {
          paymentInfo[0].setAttribute('href', url);
          paymentInfo[0].classList.remove('hide');
        }
      }
    })
    .catch(function (error) {
      console.log('error while retrieving the subscription');
      console.log('error', error);
    });
  }

  function toggleError(bool) {
    // bool true -> show error
    if(errorMessage.length < 1) return;
    errorMessage[0].classList.toggle('hide', !bool);
  };
}());
